export const countries = {
    // Países europeos
    ES: 'España',
    PT: 'Portugal',
    FR: 'Francia',
    IT: 'Italia',
    DE: 'Alemania',
    GB: 'Reino Unido',
    UK: 'Reino Unido',
    NL: 'Países Bajos',
    BE: 'Bélgica',
    AT: 'Austria',
    CH: 'Suiza',
    SE: 'Suecia',
    NO: 'Noruega',
    DK: 'Dinamarca',
    FI: 'Finlandia',
    IE: 'Irlanda',
    PL: 'Polonia',
    CZ: 'República Checa',
    HU: 'Hungría',
    RO: 'Rumania',
    BG: 'Bulgaria',
    HR: 'Croacia',
    SI: 'Eslovenia',
    SK: 'Eslovaquia',
    LT: 'Lituania',
    LV: 'Letonia',
    EE: 'Estonia',
    GR: 'Grecia',
    CY: 'Chipre',
    MT: 'Malta',
    LU: 'Luxemburgo',

    // Países americanos
    US: 'Estados Unidos',
    CA: 'Canadá',
    MX: 'México',
    BR: 'Brasil',
    AR: 'Argentina',
    CL: 'Chile',
    CO: 'Colombia',
    PE: 'Perú',
    VE: 'Venezuela',
    EC: 'Ecuador',
    BO: 'Bolivia',
    UY: 'Uruguay',
    PY: 'Paraguay',

    // Otros países comunes
    CN: 'China',
    JP: 'Japón',
    KR: 'Corea del Sur',
    IN: 'India',
    AU: 'Australia',
    NZ: 'Nueva Zelanda',
    ZA: 'Sudáfrica',
    EG: 'Egipto',
    MA: 'Marruecos',
    NG: 'Nigeria',

    // Fallback para códigos no encontrados
    UNKNOWN: 'País desconocido'
}; 